import { NgModule } from "@angular/core";

import { NgxImageCompressService } from "ngx-image-compress";
import { getClient } from "configcat-js";

import { FeatureFlagsService } from "@services/feature-flags/feature-flags.service";
import { environment } from "src/environments/environment";
import { CONFIGCAT_CLIENT } from "../constants";
import { ContextService } from "./context.service";
import { MemoryService } from "./game-data/memory.service";
import { ConstantsService } from "./constants.service";

@NgModule({
    providers: [
        ContextService,
        MemoryService,
        ConstantsService,
        NgxImageCompressService,
        {
            provide: CONFIGCAT_CLIENT,
            useFactory: () => getClient(environment.configCat.sdkKey),
        },
        FeatureFlagsService,
    ],
})
export class ServicesModule {}
